<template>
    <v-content>
        <v-app>
            <v-container grid-list-xl text-xs-center fluid class="container-transactions">
                <v-layout mb-2>
                    <v-flex xs2>
                        <v-text-field v-model="name" append-icon="search" label="Name" @change="searchHolidays" clearable @click:clear="name = null, searchHolidays()"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="period" dense :items="periodOptions" label="Period" append-icon="search" @change="searchHolidays"></v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="status" dense :items="statusOptions" label="Status" append-icon="search" @change="searchHolidays"></v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="type" dense :items="typeOptions" label="Type" append-icon="search" @change="searchHolidays"></v-select>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table :headers="tableHeaders" :items="holidays" :item-key="holidays.holidayId" :rows-per-page-items="rowsPerPage" :loading="loading" hide-actions class="elevation-1">
                            <template slot="items" slot-scope="props">
                                <tr :class="{ 'past' : props.item.date < today }">
                                    <td class="text-xs-left">{{ props.item.first_name }} {{ props.item.surname }}</td>
                                    <td class="text-xs-left">{{ prettyDatetime(props.item.date) }}</td>
                                    <td class="text-xs-left">{{ prettyDatetime(props.item.request_date) }}</td>
                                    <td class="text-xs-left">{{ props.item.type }}</td>
                                    <td v-if="!props.item.half_day" class="text-xs-left">No</td>
                                    <td v-else class="text-xs-left">{{ props.item.half_day }}</td>
                                    <td class="text-xs-left">{{ props.item.description }}</td>
                                    <td class="text-xs-left">{{ props.item.authorised_by }}</td>
                                    <td class="text-xs-left">{{ prettyDatetime(props.item.authorisation_date) }}</td>
                                    <!-- <td class="text-xs-left">
                                        <v-select v-model="props.item.status" :items="statusOptions" dense></v-select>
                                    </td> -->
                                    <td class="text-xs-center status-btn-cell">
                                        <v-btn v-if="props.item.status == 'Confirmed'" class="ma-2" :disabled="props.item.type != 'Holiday' && props.item.type != 'Sick Day'" small fab color="primary">
                                            <v-icon>check</v-icon>
                                        </v-btn>
                                        <v-btn v-else class="ma-2" small outline fab color="primary" :disabled="props.item.type != 'Holiday' && props.item.type != 'Sick Day'" @click="setStatus(props, 'Confirmed')">
                                            <v-icon>check</v-icon>
                                        </v-btn>

                                        <v-btn v-if="props.item.status == 'Pending'" class="ma-2" :disabled="props.item.type != 'Holiday' && props.item.type != 'Sick Day'" small fab dark color="#FF9800">
                                            <v-icon>mdi-help</v-icon>
                                        </v-btn>
                                        <v-btn v-else class="ma-2" small outline fab color="#FF9800" :disabled="props.item.type != 'Holiday' && props.item.type != 'Sick Day'" @click="setStatus(props, 'Pending')">
                                            <v-icon>mdi-help</v-icon>
                                        </v-btn>

                                        <v-btn v-if="props.item.status == 'Declined'" class="ma-2" :disabled="props.item.type != 'Holiday' && props.item.type != 'Sick Day'" small fab dark color="#f44336">
                                            <v-icon>close</v-icon>
                                        </v-btn>
                                        <v-btn v-else class="ma-2" small outline fab color="#f44336" :disabled="props.item.type != 'Holiday' && props.item.type != 'Sick Day'" @click="setStatus(props, 'Declined')">
                                            <v-icon>close</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
    import axios from 'axios';
    import moment from 'moment';

    export default {
        data() {
            return {
                pagination: { 'sortBy': 'processing_time', 'descending': true },  
                statusOptions: [
                                { value: "Pending", text: "Pending" },
                                { value: "Confirmed", text: "Confirmed" },
                                { value: "Declined", text: "Declined" }
                ],
                rowsPerPage:[10, 25, 50, 100],
                loading: true,
                holidays: [],
                tableHeaders: [{ text: 'Name', value: 'first_name', sortable: false },
                               { text: 'Holiday Date', sortable: false },
                               { text: 'Request Date', sortable: false },
                               { text: 'Type', sortable: false },
                               { text: 'Half Day', sortable: false },
                               { text: 'Description', sortable: false },
                               { text: 'Authorised By', sortable: false },
                               { text: 'Authorisation Date', sortable: false },
                               { text: 'Status', sortable: false, align: 'middle' }],
                status: null,
                today: moment().format('YYYY-MM-DD'),
                name: null,
                periodOptions: [
                            { value: null, text: "All" },
                            { value: 0, text: "Past" },
                            { value: 1, text: "Future" }
                ],
                period: null,
                statusOptions: [
                            { value: null, text: "All" },
                            { value: "Confirmed", text: "Confirmed" },
                            { value: "Pending", text: "Pending" },
                            { value: "Declined", text: "Declined" }
                ],
                status: null,
                typeOptions: [
                            { value: null, text: "All" },
                            { value: "Compassionate", text: "Compassionate" },
                            { value: "Event", text: "Event" },
                            { value: "Holiday", text: "Holiday" },
                            { value: "Meeting", text: "Meeting" },
                            { value: "Sick Day", text: "Sick Day" },
                            { value: "Training", text: "Training" }
                ],
                type: null
            }
        },
        beforeMount() {
            this.getAllHolidays();
        },
        methods: {
            getAllHolidays() {
                axios({
                method: 'post',
                data: { userRole: localStorage.user_role, department: localStorage.department },
                url: 'https://controlapi.totalprocessing.com/api/get-all-holidays',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.loading = false;
                    this.holidays = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            searchHolidays() {
                this.loading = true;

                axios({
                method: 'post',
                data: { name: this.name, period: this.period, status: this.status, type: this.type, userRole: parseInt(localStorage.user_role), department: parseInt(localStorage.department) },
                url: 'https://controlapi.totalprocessing.com/api/search-all-holidays',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.loading = false;
                    this.holidays = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            setStatus(e, status) {
                // console.log(e);
                const oldStatus = e.item.status;
                e.item.status = status;
                e.item.authorised_by = localStorage.name;

                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/set-holiday-status',
                data: { holidayId: e.item.holidayId, status: status, halfDay: e.item.half_day, oldStatus: oldStatus, userId: e.item.user_id, authorisedBy: localStorage.user_id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    e.item.authorisation_date = response.data.authorisation_date;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            prettyDate(date) {
                return moment(date).format('DD MMM YYYY');
            },
            prettyDatetime(date) {
                return date ? moment(date).format('DD MMM YYYY @ hh:mm') : null;
            }
        }
    }
</script>

<style>
    .past {
        background-color: #eeeeee;
    }

    .status-btn-cell {
        min-width: 190px;
    }

    .status-btn-cell .v-btn--floating.v-btn--small {
        width: 30px;
        height: 30px;
    }
</style>